import { Button, Popconfirm } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export default function BulkDelete({
  selectedRowKeys,
  deleteThunk,
  query,
  clearSelection,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showPopconfirm = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    try {
      // Loop through selected keys and delete each one
      const deletePromises = selectedRowKeys.map((id) =>
        dispatch(deleteThunk({ id }))
      );

      await Promise.all(deletePromises);
      
      setOpen(false);
      setConfirmLoading(false);
      clearSelection();
    } catch (err) {
      setOpen(false);
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Popconfirm
      title={t("common.bulkDeleteContent", { count: selectedRowKeys.length })}
      open={open}
      placement="topLeft"
      onConfirm={handleOk}
      okButtonProps={{
        loading: confirmLoading,
      }}
      onCancel={handleCancel}>
      <Button danger onClick={showPopconfirm}>
        {t("common.delete")} ({selectedRowKeys.length})
      </Button>
    </Popconfirm>
  );
}
